var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "display-inline-block" },
    [
      _c("block", {
        ref: "block",
        attrs: {
          "block-color": _vm.blockColor,
          "block-hover-primary-color": _vm.blockHoverPrimaryColor,
          "block-hover-secondary-color": _vm.blockHoverSecondaryColor,
          "block-size": _vm.blockSize,
          "coin-color": _vm.coinColor,
          "is-showing-hover-initially": _vm.isShowingHoverInitially,
          "has-hit-bop-limit": _vm.hasHitBopLimit,
        },
        on: { bop: _vm.handleBlockInteraction },
      }),
      _vm._v(" "),
      _c("hud", {
        attrs: {
          "is-showing": _vm.isShowingHud,
          "global-bop-count": _vm.globalBopCount,
          "one-up-count": _vm.oneUpCount,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }